import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AccountService } from '../shared/services/account/account.services';

/**
 * Block some route if is not logged
 */
@Injectable()
export class AuthGuardService implements CanActivate
{
    constructor(
        private readonly accountService: AccountService,
        private readonly router: Router
    )
    { }

    /**
     * Security guard for some routes
     */
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this.accountService.isAuthenticated().subscribe(success => {
            return true;
        }, error => {
            void this.router.navigate(['/']);
        });
        return true;
    }
}
